export const SET_TENANT_FEED = 'SET_TENANT_FEED';
export const SET_IS_LOADING_SET_TENANT_FEED = 'SET_IS_LOADING_SET_TENANT_FEED';
export const GET_VIDEOS_BY_BRAND = 'GET_VIDEOS_BY_BRAND';
export const GET_PRODUCTS_BY_BRAND = 'GET_PRODUCTS_BY_BRAND';
